<template>
  <div class="contact">
    <h2>Contacter {{ $store.state.siteConst.name }}</h2>
    <p>
      Veuillez entrer votre message dans le formulaire ci-dessous. Vous recevrez notre réponse par mail dans les
      prochains jours.
    </p>
    <div class="contactForm">
      <label
        >Objet : <strong>{{ sujet }}</strong></label
      >
      <textarea v-model="contenu"></textarea>
      <a @click.prevent="send" href="#" class="bouton">Envoyer</a>
    </div>
  </div>
</template>

<script>
import BasePage from "@/components/pages/BasePage";
import { idyuJsonRpc } from "@/assets/js/idyu/connect.js";

export default {
  name: "Contact",
  extends: BasePage,
  data: function() {
    return {
      contenu: null
    };
  },
  methods: {
    send() {
      idyuJsonRpc("sendEmail", this.$store.state.user.email, this.sujet, this.contenu);
    }
  },

  computed: {
    sujet() {
      if (this.$route.params.sujet) return this.$route.params.sujet;
      return "Formulaire de contact";
    }
  }
};
</script>

<style scoped lang="scss">
@import "@/assets/css/vars.scss";

.contact {
  background-color: white;
  border: $light_border;
  padding: 10px;
}

textarea {
  height: 100px;
  font-size: 16px;
}

.contactForm {
  display: grid;
  grid-gap: 10px;
  margin-top: 10px;
}
</style>
